module.exports = __webpack_public_path__ + "img/pallet.312ddb26.svg";